import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class CoinTossFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.CoinToss;
    }

    getComment(play, fragment, serializationContext) {
        const { id: offenseTeamId } = fragment.settings.offenseTeam;
        const { id: tossWinnerId } = fragment.settings.tossWinner;
        const { homeTeam, awayTeam } = serializationContext;
        const { teamName: awayTeamName, id: awayId } = awayTeam;
        const { teamName: homeTeamName, id: homeId } = homeTeam;
        const teamMap = { [awayId]: awayTeamName, [homeId]: homeTeamName };

        return `${teamMap[tossWinnerId]} won toss. ${teamMap[offenseTeamId]} starts offensive.`;
    }

    getRawFragment(play, serializationContext, fragment) {
        return `CMT:${this.getComment(play, fragment, serializationContext)}`;
    }

    isCommentSerializer() {
        return true;
    }
}
